const thirdPartyDOTD = function(){
	let thirdPartyDialog;
	
	const check = () => {
		thirdPartyCheck();
	},
	thirdPartyCheck = () => {
		fetch('/dealoftheday/account/IsUserThirdParty', {
			method: 'get',
			headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "Cache-Control": "no-cache" }
		}).then(function (response) {
			return (response.ok) ? response.text() : []; // response.json() returns a promise
		}).then(function (responsebody) {
			if (responsebody === 'True') {
				init();
				thirdPartyDialog.Open();
			} else { }
		});
	},
	init = () => {
		thirdPartyDialog = new Dialog4i();
		thirdPartyDialog.Init({
			triggerElements: [],
			dialogClass: "mediumDialog",
			title: "Warning",
			content: getContent(),
			onOpen: open
		});
	},
	getContent = () => {
		return `
			<div id="thirdPartyDialogContent">
				<p class="textCenter">You are entering a site that is not supported by Punchout, please press the "Return to Punchout" button to restore your session.</p>
				<div class="smallSpace displayFlex flexJustifyCenter">
					<a class="button-lg text16 bkgdBlue whiteLink" href="https://www.4imprint.com">Return to Punchout</a>
				</div>
			</div>
		`;
	};
	return{
		Check: check
	};
};

(function(){
	const thirdParty = new thirdPartyDOTD();
	thirdParty.Check();
})();